import { dataLowSquare } from 'dls-icons-data'
import { createIcon } from '../common'

const IconLowSquare = /*#__PURE__*/createIcon(dataLowSquare)
export default IconLowSquare
